import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block } from '@guryou/html-components';
import { useOnboardContext } from 'onboard/context';
import { dealTokens, SystemButton } from 'components/shared';

const StepButtons = ({ finish, showPreviousButton = true }) => {
  const { t } = useTranslation();
  const { backActiveStep } = useOnboardContext();
  return (
    <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
      <div style={{ display: 'flex', gap: dealTokens.space[3] }}>
        {showPreviousButton && (
          <SystemButton type="button" variant="ghost" onClick={() => backActiveStep()}>
            {t('ONBOARD.prev')}
          </SystemButton>
        )}
        <SystemButton type="submit" variant="primary">
          {finish ? t('ONBOARD.finish') : t('ONBOARD.next')}
        </SystemButton>
      </div>
    </Block>
  );
};

export default StepButtons;
